import { useState } from "react";
import { useParams } from "react-router-dom";
import { authenticatedFetch } from '@/services/auth/authenticatedFetch.js';

export const useGetExpenseReportProof_AsAdmin = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);
    const { id: consultantUuid } = useParams();


    const getExpenseProof = async (expenseReportFileUuid) => {
        setLoading(true);
        setError(null);
        // f4bfbb4b-e9ee-4937-bee8-202c455be206
        try {
            const response = await authenticatedFetch(
                window.ENV.BACKEND_URL+`/api/secured/admin/expense/expenseReportProof/${consultantUuid}/${expenseReportFileUuid}`, {
                method: "GET",
            });

            if (!response.ok) {
                throw new Error("Failed to retrieve expense invoice");
            }
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            // console.log("blob file expense ", blob, url,"contentLength", contentLength,"blob.size" ,blob?.size)

            setData({ url, type: blob.type });
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };
    if (!consultantUuid) return { getExpenseProof, loading, error: "user from authentification or consultantUuid are null", data, refetch: getExpenseProof };

    return { getExpenseProof, loading, error, data, refetch: getExpenseProof };
};
